import React from "react";

import { Icon } from "components/Icon";

import {
    TRAFFIC_LIMIT_COL_WIDTH,
    TRAFFIC_LIMIT_UNEDITABLE,
    TRAFFIC_LIMIT_CREATING_CODE,
    TRAFFIC_LIMIT_EDITING_CODE,
    applyValidationErrors,
    replaceByIndex,
    removeByIndex,
    normalizeTrafficLimitValue,
    getNextTrafficLimitKey,
    getTrafficLimitSaveDisabled,
    upsertTrafficLimitByKey,
    replaceTrafficLimitByKey,
} from "./TrunkFormRefactored.utils";
import {
    Header,
    TrafficLimitHeader,
    TrafficLimitHeaderItem,
    StyledGrid,
    StyledList,
    StyledListItem,
    TrafficLimitForm,
    StyledStatusIndexContainer,
    StyledField,
    StyledButtonContainer,
    SaveButton,
    CancelButton,
    EditButton,
    AddNewButton,
} from "./TrunkFormRefactored.styles";

import { Form } from "rsuite";

const TrafficLimitSection = ({
    isMobile,
    isTransitTrunks,
    trafficLimitKeyList,
    trafficLimitEditData,
    initTrafficLimitList,
    formTrafficLimitRef,
    trafficLimitModel,
    setError,
    setTrafficLimitKeyList,
    setTrafficLimitEditData,
    acceptedTrafficLimitList,
    setAcceptedTrafficLimitList,
}) => {
    const trafficLimitShowBorder = isTransitTrunks ? trafficLimitKeyList.length > 2 : trafficLimitKeyList.length > 3;
    const trafficLimitMaxHeight = isTransitTrunks ? 200 : 250;

    return <>
        <Header ml={50}>Default message limit per one number</Header>

        <TrafficLimitHeader>
            <TrafficLimitHeaderItem width={TRAFFIC_LIMIT_COL_WIDTH.INDEX + TRAFFIC_LIMIT_COL_WIDTH.SENDERID} paddingLeft={TRAFFIC_LIMIT_COL_WIDTH.INDEX}>
                Senderid
            </TrafficLimitHeaderItem>
            <TrafficLimitHeaderItem width={TRAFFIC_LIMIT_COL_WIDTH.DAY}>
                Day
            </TrafficLimitHeaderItem>
            {!isTransitTrunks && <TrafficLimitHeaderItem width={TRAFFIC_LIMIT_COL_WIDTH.HOUR}>
                Hour
            </TrafficLimitHeaderItem>}
        </TrafficLimitHeader>

        <StyledGrid
            isMobile={isMobile}
            style={{ margin: 0, marginLeft: 30 }}
            showBorder={trafficLimitShowBorder}
            maxHeight={trafficLimitMaxHeight}
            className="list-container"
        >
            <StyledList>
                {trafficLimitKeyList.map((trafficLimit, idx) => {
                    const editableRowsDisabled = !([TRAFFIC_LIMIT_CREATING_CODE, TRAFFIC_LIMIT_EDITING_CODE].includes(trafficLimitEditData[trafficLimit.key]?.editing));
                    const currentFormValue = trafficLimitEditData[trafficLimit.key];
                    const defaultTrafficLimit = initTrafficLimitList.find((initTrafficLimitValue) => {
                        return initTrafficLimitValue.key === trafficLimit.key;
                    }) || {};

                    const savedButtonDisabled = getTrafficLimitSaveDisabled({
                        defaultTrafficLimit,
                        trafficLimit,
                        isTransitTrunks,
                    });

                    return (<StyledListItem>
                        <TrafficLimitForm
                            ref={ref => formTrafficLimitRef[trafficLimit.key] = ref}
                            model={trafficLimitModel}
                            onChange={(formValue) => {
                                const currentValue = { ...trafficLimit, ...formValue };
                                const checkedFormValue = trafficLimitModel.check(currentValue);

                                applyValidationErrors(setError, "trafficLimitErrors", trafficLimit.key, checkedFormValue);
                                setTrafficLimitKeyList((prevTrafficLimit) => {
                                    const normalizedFormValue = normalizeTrafficLimitValue(formValue, isTransitTrunks);
                                    const nextValue = {
                                        ...prevTrafficLimit[idx],
                                        ...normalizedFormValue,
                                    };

                                    return replaceByIndex(prevTrafficLimit, idx, nextValue);
                                });

                                setTrafficLimitEditData((prevTrafficLimit) => {
                                    const normalizedFormValue = normalizeTrafficLimitValue(formValue, isTransitTrunks);
                                    const currentPrevTrafficLimit = { ...prevTrafficLimit };
                                    currentPrevTrafficLimit[formValue.key] = {
                                        ...currentPrevTrafficLimit[formValue.key],
                                        ...normalizedFormValue,
                                    };
                                    return currentPrevTrafficLimit;
                                });
                            }}
                            formValue={currentFormValue}
                        >
                            <StyledStatusIndexContainer width={TRAFFIC_LIMIT_COL_WIDTH.INDEX}>
                                <span className="index">{idx + 1}</span>
                            </StyledStatusIndexContainer>
                            <StyledField style={{ width: TRAFFIC_LIMIT_COL_WIDTH.SENDERID }}>
                                <Form.Control
                                    value={trafficLimit.senderid}
                                    name="senderid"
                                    placeholder="Senderid"
                                    errorPlacement="topEnd"
                                    disabled={![TRAFFIC_LIMIT_CREATING_CODE].includes(currentFormValue?.editing)}
                                />
                            </StyledField>
                            <StyledField style={{ width: TRAFFIC_LIMIT_COL_WIDTH.DAY }}>
                                <Form.Control
                                    value={trafficLimit.day}
                                    name="day"
                                    placeholder="Day"
                                    errorPlacement="topEnd"
                                    disabled={editableRowsDisabled}
                                />
                            </StyledField>
                            {!isTransitTrunks && <StyledField style={{ width: TRAFFIC_LIMIT_COL_WIDTH.HOUR }}>
                                <Form.Control
                                    value={trafficLimit.hour}
                                    name="hour"
                                    placeholder="Hour"
                                    errorPlacement="topEnd"
                                    disabled={editableRowsDisabled}
                                />
                            </StyledField>}

                            <StyledButtonContainer style={{ width: TRAFFIC_LIMIT_COL_WIDTH.ACTIONS }}>
                                {([TRAFFIC_LIMIT_CREATING_CODE, TRAFFIC_LIMIT_EDITING_CODE].includes(trafficLimitEditData[trafficLimit.key]?.editing))
                                    && Object.keys(trafficLimitEditData[trafficLimit.key]).length ? <>
                                    <SaveButton
                                        appearance="ghost"
                                        onClick={async () => {
                                            const currentTrafficLimit = {
                                                key: trafficLimit?.key,
                                                senderid: trafficLimit.senderid || "",
                                                day: parseInt(trafficLimit.day || 0, 10),
                                                ...(isTransitTrunks ? {} : { hour: parseInt(trafficLimit.hour || 0, 10) })
                                            };

                                            const nextAcceptedTrafficLimitList = replaceTrafficLimitByKey(
                                                trafficLimitKeyList,
                                                trafficLimit.key,
                                                currentTrafficLimit
                                            );

                                            setAcceptedTrafficLimitList(nextAcceptedTrafficLimitList);

                                            setTrafficLimitKeyList(prev => {
                                                return upsertTrafficLimitByKey(prev, currentTrafficLimit);
                                            });

                                            setTrafficLimitEditData((prevTrafficLimit) => {
                                                const currentPrevTrafficLimit = { ...prevTrafficLimit };
                                                currentPrevTrafficLimit[trafficLimit.key] = {
                                                    ...currentPrevTrafficLimit[trafficLimit.key],
                                                    ...trafficLimit,
                                                    editing: TRAFFIC_LIMIT_UNEDITABLE
                                                };
                                                return currentPrevTrafficLimit;
                                            });

                                        }}
                                        disabled={savedButtonDisabled}
                                    >
                                        <Icon icon="check-circle" />
                                    </SaveButton>
                                    <CancelButton
                                        appearance="ghost"
                                        onClick={() => {
                                            if (
                                                [TRAFFIC_LIMIT_CREATING_CODE].includes(trafficLimitEditData[trafficLimit.key]?.editing)
                                            ) {
                                                const currentTrafficLimitKeyList = removeByIndex(trafficLimitKeyList, idx);

                                                setTrafficLimitKeyList(currentTrafficLimitKeyList);
                                                setTrafficLimitEditData((prevTrafficLimit) => {
                                                    const currentTrafficLimit = { ...prevTrafficLimit };
                                                    delete currentTrafficLimit[trafficLimit.key];
                                                    delete currentTrafficLimit[undefined];
                                                    return currentTrafficLimit;
                                                });
                                            } else {
                                                const acceptedTrafficLimit = acceptedTrafficLimitList.find((acceptedValue) => {
                                                    return acceptedValue.key === trafficLimit.key;
                                                });
                                                const canceledTrafficLimitList = replaceTrafficLimitByKey(
                                                    trafficLimitKeyList,
                                                    trafficLimit.key,
                                                    acceptedTrafficLimit
                                                );

                                                setTrafficLimitKeyList(canceledTrafficLimitList);
                                                setTrafficLimitEditData((prevTrafficLimitValue) => {
                                                    const currentPrevTrafficLimit = { ...prevTrafficLimitValue };

                                                    const currentAcceptedTrafficLimit = acceptedTrafficLimitList.find((acceptedTrafficLimit) => {
                                                        return acceptedTrafficLimit.key === trafficLimit.key;
                                                    }) || {};

                                                    currentPrevTrafficLimit[trafficLimit.key] = {
                                                        ...currentAcceptedTrafficLimit,
                                                        editing: TRAFFIC_LIMIT_UNEDITABLE
                                                    };

                                                    delete currentPrevTrafficLimit[undefined];

                                                    return currentPrevTrafficLimit;
                                                });
                                            }
                                        }}
                                    >
                                        <Icon icon="close-circle" />
                                    </CancelButton>
                                </> : [TRAFFIC_LIMIT_UNEDITABLE].includes(trafficLimitEditData[trafficLimit.key]?.editing) &&
                                <EditButton
                                    appearance="ghost"
                                    onClick={() => {
                                        setTrafficLimitEditData((prevTrafficLimit) => {
                                            const currentPrevTrafficLimit = { ...prevTrafficLimit };
                                            currentPrevTrafficLimit[trafficLimit.key] = {
                                                ...currentPrevTrafficLimit[trafficLimit.key],
                                                editing: TRAFFIC_LIMIT_EDITING_CODE
                                            };
                                            return currentPrevTrafficLimit;
                                        });
                                    }}
                                >
                                    <Icon icon="edit" />
                                </EditButton>}
                                {!(trafficLimit.key && trafficLimit.key.toString().startsWith("new")
                                    || idx === 0 && trafficLimit.senderid === null) ? <Icon
                                    onClick={() => {
                                        const currentTrafficLimitKeyList = removeByIndex(trafficLimitKeyList, idx);

                                        setTrafficLimitKeyList(currentTrafficLimitKeyList);
                                        setAcceptedTrafficLimitList(currentTrafficLimitKeyList);
                                        setTrafficLimitEditData((prevTrafficLimit) => {
                                            const currentTrafficLimit = { ...prevTrafficLimit };
                                            delete currentTrafficLimit[trafficLimit.key];
                                            return currentTrafficLimit;
                                        });
                                    }}
                                    className="delete_traffic"
                                    icon="trash"
                                /> : <></>}
                            </StyledButtonContainer>
                        </TrafficLimitForm>
                    </StyledListItem>);
                })}
                <AddNewButton
                    ml={36}
                    appearance="ghost"
                    onClick={() => {
                        const newKey = getNextTrafficLimitKey(trafficLimitEditData);

                        const newTrafficLimit = {
                            key: newKey, hour: null, day: null, senderid: "", editing: TRAFFIC_LIMIT_CREATING_CODE
                        };

                        const newTrafficLimitKeyList = [...trafficLimitKeyList, newTrafficLimit].sort((a, b) => {
                            return a.key > b.key;
                        });

                        setTrafficLimitKeyList(newTrafficLimitKeyList);

                        setTrafficLimitEditData((prevTrafficLimit) => {
                            const currentPrevTrafficLimit = { ...prevTrafficLimit };
                            currentPrevTrafficLimit[newKey] = newTrafficLimit;
                            return currentPrevTrafficLimit;
                        });
                    }}
                >
                    <Icon icon="plus" /> Add new{trafficLimitKeyList && !trafficLimitKeyList.length ? " traffic limit" : ""}
                </AddNewButton>

            </StyledList>
        </StyledGrid>
    </>;
};

export default TrafficLimitSection;
